import { forwardRef } from "react";

import {
  Core,
  Password,
  DigitSeparated,
  Date,
  TextArea,
  File,
} from "./Variants";

// eslint-disable-next-line react/display-name
const Input = forwardRef(
  (
    {
      label,
      required,
      size,
      name,
      prefix,
      suffix,
      mask,
      gridArea,
      margin,
      ...rest
    },
    ref,
  ) => {
    switch (rest?.type) {
      case "file":
        return (
          <File
            ref={ref}
            label={label}
            required={required}
            size={size}
            name={name}
            prefix={prefix}
            suffix={suffix}
            mask={mask}
            gridArea={gridArea}
            margin={margin}
            {...rest}
          />
        );
      case "password":
        return (
          <Password
            ref={ref}
            label={label}
            required={required}
            size={size}
            name={name}
            prefix={prefix}
            suffix={suffix}
            mask={mask}
            gridArea={gridArea}
            margin={margin}
            {...rest}
          />
        );
      case "digit-separated":
        return (
          <DigitSeparated
            ref={ref}
            label={label}
            required={required}
            size={size}
            name={name}
            prefix={prefix}
            suffix={suffix}
            mask={mask}
            gridArea={gridArea}
            margin={margin}
            {...rest}
          />
        );
      case "date":
      case "datetime-local":
        return (
          <Date
            ref={ref}
            label={label}
            required={required}
            size={size}
            name={name}
            prefix={prefix}
            suffix={suffix}
            mask={mask}
            gridArea={gridArea}
            margin={margin}
            {...rest}
          />
        );

      case "textarea":
        return (
          <TextArea
            ref={ref}
            label={label}
            required={required}
            size={size}
            name={name}
            prefix={prefix}
            suffix={suffix}
            mask={mask}
            gridArea={gridArea}
            margin={margin}
            {...rest}
          />
        );

      default:
        return (
          <Core
            ref={ref}
            label={label}
            required={required}
            size={size}
            name={name}
            prefix={prefix}
            suffix={suffix}
            mask={mask}
            gridArea={gridArea}
            margin={margin}
            {...rest}
          />
        );
    }
  },
);

export default Input;
